import { put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { fetchSettingByCode } from 'APIPackage/AdminModule/services/adminCatalogsExportsApi';

import {
  userNotificationGetData,
  userNotificationGetFetchSettingByCode,
  userNotificationReadStatusUpdate,
  userNotificationSetData,
  userNotificationSetFetchSettingByCode,
  userNotificationUnreadGetCount,
  userNotificationUnreadSetCount,
} from '../actions/UserNotificationAction';
import { UserNotificationActionEnum } from '../enums/UserNotificationActionEnum';
import {
  fetchNotification,
  notificationReadStatusUpdate,
} from '../../../APIPackage/UserNotificationModule/services/notificationApi';
import { INotificationWithPaginationResponse } from '../../../APIPackage/UserNotificationModule/interfaces/INotificationResponse';
import { NotificationSearchTypeEnum } from '../enums/NotificationSearchTypeEnum';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { COUNT_ON_PAGE } from '../constants';

export function* watchUserNotificationSaga() {
  yield takeEvery(UserNotificationActionEnum.USER_NOTIFICATIONS_GET_DATA, userNotificationGetDataSaga);
  yield takeEvery(
    UserNotificationActionEnum.USER_NOTIFICATIONS_GET_FETCH_SETTING_BY_CODE,
    userNotificationGetFetchSettingByCodeSaga,
  );
  yield takeEvery(UserNotificationActionEnum.USER_NOTIFICATIONS_GET_UNREAD_COUNT, userNotificationGetUnreadCountSaga);
  yield takeEvery(
    UserNotificationActionEnum.USER_NOTIFICATIONS_READ_STATUS_UPDATE,
    userNotificationReadStatusUpdateSaga,
  );
}

function* userNotificationGetDataSaga(action: ActionType<typeof userNotificationGetData>) {
  function* funcTry() {
    const { searchType, searchValue, page } = action.payload;

    const result: INotificationWithPaginationResponse = yield fetchNotification({
      searchType,
      searchValue,
      size: page ? ((parseInt(page, 10) + 1) * parseInt(COUNT_ON_PAGE, 10)).toString() : COUNT_ON_PAGE,
      page: '0',
      order: 'createdAt,desc',
    });

    yield put(userNotificationSetData(result));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* userNotificationGetFetchSettingByCodeSaga(action: ActionType<typeof userNotificationGetFetchSettingByCode>) {
  function* funcTry() {
    const { code } = action.payload;

    const response: IAdminSetting = yield fetchSettingByCode(code);

    yield put(userNotificationSetFetchSettingByCode(response));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* userNotificationGetUnreadCountSaga() {
  function* funcTry() {
    const result: INotificationWithPaginationResponse = yield fetchNotification({
      searchType: NotificationSearchTypeEnum.UNREAD,
      searchValue: undefined,
    });

    yield put(userNotificationUnreadSetCount(result));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* userNotificationReadStatusUpdateSaga(action: ActionType<typeof userNotificationReadStatusUpdate>) {
  function* funcTry() {
    const { request } = action.payload;

    yield notificationReadStatusUpdate(request);
    yield put(userNotificationUnreadGetCount());
    const state: IRootState = yield select();
    const searchType = state.userNotification.searchTypeSelectOption.id as NotificationSearchTypeEnum;
    const { searchText, page } = state.userNotification;

    yield put(userNotificationGetData(searchType, searchText, page.toString()));
  }

  yield sagaWrapper({
    funcTry,
  });
}
